import React from 'react';
import { AppBar, Toolbar, Typography, Button, Box } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import SchoolIcon from '@mui/icons-material/School';

function Navbar() {
  return (
    <AppBar position="static">
      <Toolbar>
        <SchoolIcon sx={{ mr: 2 }} />
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          Language Learning Companion
        </Typography>
        <Box>
          <Button color="inherit" component={RouterLink} to="/">
            Home
          </Button>
          <Button color="inherit" component={RouterLink} to="/daily-word">
            Daily Word
          </Button>
          <Button color="inherit" component={RouterLink} to="/flashcards">
            Flashcards
          </Button>
          <Button color="inherit" component={RouterLink} to="/quizzes">
            Quizzes
          </Button>
          <Button color="inherit" component={RouterLink} to="/streaks">
            Streaks
          </Button>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar; 